import { getJson, postJson } from 'api/baseApi'

export const getSelectedFolder = function () {
  return getJson({ url: '/api/server/folders/selectedFolderId' })
}

export const getFolderData = function (folderId, pageNumber, count, filtersList) {
  return postJson({ url: `/api/server/vuedocumentgrid/getDocuments/${folderId}/${pageNumber}/${count}`, data: filtersList })
}

export const getVersionsData = function (documentId) {
  return getJson({ url: `/api/server/vuedocumentgrid/getVersions/${documentId}` })
}

export const getFolderHeader = function (folderId) {
  return getJson({ url: '/api/server/vuedocumentgrid/getColumnsHeaders/' + folderId })
}

export const requestFacetValues = function (folderId, columnName, filtersList) {
  return postJson({ url: '/api/server/vuedocumentgrid/getFacets/' + folderId + '/' + columnName, data: filtersList })
}

export const selectDocument = function (documentId) {
  return window.fetch('/Events/Document/DocumentEvents.aspx?id=' + documentId + '&action=selectDocumentById', {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(response => {
    return response.text()
  }).then(result => {
    if (result.indexOf('|') === 1) {
      result = result.slice(2)
      // document.cookie = 'ds_h=' + result
    }
    try {
      window.parent.getTop().createCookie('ds_h', result)
    } catch (e) { }
  })
}

export const selectDocumentVersion = function (versionId) {
  return window.fetch('/Events/Document/DocumentEvents.aspx?id=' + versionId + '&action=selectDocumentVersionById', {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(response => {
    return response.text()
  }).then(result => {
    if (result.indexOf('|') === 1) {
      result = result.slice(2)
      // document.cookie = 'ds_h=' + result
    }
    try {
      window.parent.getTop().createCookie('ds_h', result)
    } catch (e) { }
  })
}

export const checkDocumentVersion = function (versionId) {
  return window.fetch('/Events/Document/DocumentEvents.aspx?id=' + versionId + '&action=checkDocumentVersion', {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(response => {
    return response.text()
  }).then(result => {
    if (result.indexOf('|') === 1) {
      result = result.slice(2)
      // document.cookie = 'ds_h=' + result
    }
    try {
      window.parent.getTop().createCookie('ds_h', result)
    } catch (e) {}
  })
}

export const uncheckDocumentVersion = function (versionId) {
  return window.fetch('/Events/Document/DocumentEvents.aspx?id=' + versionId + '&action=checkDocumentVersion', {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(response => {
    return response.text()
  }).then(result => {
    if (result.indexOf('|') === 1) {
      result = result.slice(2)
      // document.cookie = 'ds_h=' + result
    }
    try {
      window.parent.getTop().createCookie('ds_h', result)
    } catch (e) {}
  })
}

export const checkAllDocumentVersions = function (value) {
  return window.fetch(`/Events/Document/DocumentEvents.aspx?value=${value}&action=checkAllVersions`, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(response => {
    return response.text()
  })
}



// WEBPACK FOOTER //
// ./src/api/folderApi.js